import React, { Component } from 'react';
import {
  Card, CardBody, Col, Table,
} from 'reactstrap';
import PropTypes from 'prop-types';
import { Link, Redirect } from 'react-router-dom';
import { withTranslation } from 'react-i18next';

import Inventory from '../../../services/InventoryService';
import global from '../../../global';

class InventoryDashboard extends Component {
  static propTypes = {
    type: PropTypes.string.isRequired,
  };

  constructor(props) {
    super(props);
    const { type } = this.props;
    this.state = {
      list: [],
      pageType: type,
      goTo: false,
      goToPage: '/',
    };
    this.isLoading = false;
    this.userdata = JSON.parse(localStorage.getItem('userData'));
  }

  componentDidMount() {
    this.isLoading = true;
    const { pageType } = this.state;
    this.onLoadInventory(pageType);
  }

  componentWillReceiveProps(newProps) {
    const { type } = newProps;
    this.onLoadInventory(type);
  }

  componentWillUnmount() {
    this.isLoading = false;
  }

  onLoadInventory = (type) => {
    Inventory.getInventory(type).then((response) => {
      const result = response;
      if (this.isLoading) {
        this.setState({ list: result, pageType: type });
      }
    }).catch((error) => {
      console.log('Error: ', error.message);
    });
  }

  goTo = (ev) => {
    this.setState({ goTo: true, goToPage: `/${ev.currentTarget.dataset.href}` });
  }

  render() {
    const {
      list,
      goTo,
      pageType,
      goToPage,
    } = this.state;

    if (goTo === true) {
      return <Redirect to={goToPage} />;
    }

    if (this.userdata === null || ['1', '5', '6'].indexOf(this.userdata.type) === -1) {
      return (<Redirect to="/login" />);
    }

    return (
      <Col md={12}>
        <Card className="panel panel--primary" id="users_table">
          <CardBody className="panel__body">
            <div className="panel__title bg_blue">
              <h5 className="bold-text">
                {pageType === 'logistic' ? 'Logistic' : pageType === 'retailstore' ? 'Retail Store' : 'Warehouse'}
              </h5>
              <div className="panel__btns">
                  <Link
                    className={`btn btn-sm btn-header btn-awesome ${pageType === 'warehouse' ? 'active' : ''}`}
                    to="/inventory/warehouse/list"
                  >
                    <i className="fa fa-warehouse" />
                    <span>Warehouse</span>
                  </Link>
                  <Link
                    className={`btn btn-sm btn-header btn-awesome ${pageType === 'logistic' ? 'active' : ''}`}
                    to="/inventory/logistic/list"
                  >
                    <i className="fa fa-box" />
                    <span>Logistic</span>
                  </Link>

                  {
                    this.userdata && (this.userdata.type !== '6') && (
                    <Link
                      className={`btn btn-sm btn-header btn-awesome ${pageType === 'retailstore' ? 'active' : ''}`}
                      to="/inventory/retailstore/list"
                    >
                      <i className="fa fa-store" />
                      <span>Retail Store</span>
                    </Link>
                    )
                  }
              </div>
            </div>
            <div className="panel__content">
              <Table responsive hover striped className="doResTable">
                <thead>
                  <tr>
                    <th>Location</th>
                    { pageType === 'warehouse' ? (
                      <>
                        <th className="text-center">Stock Received</th>
                        <th className="text-center">Stock Withdrawn</th>
                        <th className="text-center">Stock Sold</th>
                        <th className="text-center">Stock Balance</th>
                      </>
                    ) : (
                      <>
                        {/* <th className="text-center">Beginning</th> */}
                        <th className="text-center">Received</th>
                        <th className="text-center">Transfered</th>
                        <th className="text-center">Total Out</th>
                        <th className="text-center">New Balance</th>
                      </>
                    )}
                    {
                      this.userdata && (this.userdata.type !== '5') && (
                        <th className="text-center">Grand Total</th>
                      )
                    }
                  </tr>
                </thead>
                <tbody>
                  {
                    list !== false || list.length > 0 ? list.map((item) => {
                      const totalIn = item.total_in;
                      const totalOut = item.total_out;
                      const totalTransfer = item.total_transfer;
                      const stockBalance = item.total_stock_balance;
                      const grandTotal = item.grand_total;

                      return (
                        <tr key={item.location_id} onClick={this.goTo} data-href={`inventory/${pageType}/dashboard/${item.location_id}`} className="text-center">
                          <td className="text-left">{item.location_name}</td>
                          {
                            pageType === 'warehouse' ? (
                              <>
                                <td>{totalIn && totalIn !== 0 ? `${global.numberFormat(totalIn)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{totalTransfer && totalTransfer !== 0 ? `${global.numberFormat(totalTransfer)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{totalOut && totalOut !== 0 ? `${global.numberFormat(totalOut)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{stockBalance && stockBalance !== 0 ? `${global.numberFormat(stockBalance)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                {
                                  this.userdata && (this.userdata.type !== '5') && (
                                    <td>{grandTotal && grandTotal !== 0 ? <span>&#x20b1; {global.numberFormat(grandTotal)}</span> : <strong className="text-warning">0</strong>}</td>
                                  )
                                }
                              </>
                            ) : (
                              <>
                                {/* <td>{item.total_beginning && item.total_beginning !== 0 ? `${item.total_beginning} kgs.` : <strong className="text-warning">0</strong>}</td> */}
                                <td>{totalIn && totalIn !== 0 ? `${global.numberFormat(totalIn)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{totalTransfer && totalTransfer !== 0 ? `${global.numberFormat(totalTransfer)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{totalOut && totalOut !== 0 ? `${global.numberFormat(totalOut)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                <td>{stockBalance && stockBalance !== 0 ? `${global.numberFormat(stockBalance)} kgs.` : <strong className="text-warning">0</strong>}</td>
                                {
                                  this.userdata && (this.userdata.type !== '5') && (
                                    <td>{grandTotal && grandTotal !== 0 ? <span>&#x20b1; {global.numberFormat(grandTotal)}</span> : <strong className="text-warning">- -</strong>}</td>
                                  )
                                }
                              </>
                            )
                          }

                        </tr>
                      );
                    }) : (
                      <tr className="text-center">
                        <td colSpan="8">No data available..</td>
                      </tr>
                    )
                  }
                </tbody>
              </Table>
            </div>
          </CardBody>
        </Card>
      </Col>
    );
  }
}

export default withTranslation('common')(InventoryDashboard);
